<script setup lang="ts">
import Card from "./trainings-tab/Card.vue";
import { useLearningPathTrainingsStore } from "~/store/learning-path/learning-path-trainings.store";
import SessionsModal from "../../modal/sessions/SessionsModal.vue";
import EmptyState from "~/components/Common/EmptyState.vue";

const {
  setCurrentTrainingPathId,
  resetSessionsCheck,
  setShouldCloseCollapse,
  cronFetchTrainings,
  stopCronFetchTrainings,
} = useLearningPathTrainingsStore();
const { trainingsDatas, learningPathTrainingsSessionsModal, shouldCloseCollapse } = storeToRefs(
  useLearningPathTrainingsStore(),
);
const route = useRoute();
const learningPathId = (route.query.learning_path_id as string) || null;

// Manage the opened training id
const openedLearningPathTrainingId = ref<string | null>(null);

function handleToggle(learningPathTrainingId: string) {
  // If the training card is already opened, close it
  if (openedLearningPathTrainingId.value === learningPathTrainingId) {
    openedLearningPathTrainingId.value = null;
    setCurrentTrainingPathId(null);
  } else {
    // Otherwise, open the new card (which closes the other one automatically)
    openedLearningPathTrainingId.value = learningPathTrainingId;
    setCurrentTrainingPathId(learningPathTrainingId);
  }
}

// watch to close the collapse only after confirmation
watch(
  () => learningPathTrainingsSessionsModal.value,
  (newValue, oldValue) => {
    // when the modal is closed and the collapse should be closed
    if (oldValue === true && newValue === false && shouldCloseCollapse.value) {
      openedLearningPathTrainingId.value = null;
      setCurrentTrainingPathId(null);
      resetSessionsCheck();
      setShouldCloseCollapse(false);
    }
  },
);

onMounted(async () => {
  if (learningPathId) {
    await cronFetchTrainings(learningPathId);
  }
});

onUnmounted(() => {
  stopCronFetchTrainings();
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <h3 class="heading_3_demi text-primary-color p-2">Revue des inscriptions manquantes</h3>
    <EmptyState
      v-if="!trainingsDatas?.length"
      message="Tous les participants sont inscrits aux formations"
      icon="target-menu"
      size="medium"
      class="mt-10"
    >
      <div class="flex gap-1">
        <span class="body_regular text-medium-grey-color"
          >Rendez-vous sur l'onglet "Participants" pour voir le récapitulatif des participants inscrits.</span
        >
      </div>
    </EmptyState>
    <div v-else class="users-table-container">
      <Card
        v-for="(training, index) in trainingsDatas"
        :key="training.learningPathTrainingId"
        :index="Number(index)"
        :training="training"
        :disabled="false"
        :is-open="openedLearningPathTrainingId === training.learningPathTrainingId"
        @toggle="handleToggle"
      />
    </div>
  </div>
  <SessionsModal v-if="learningPathTrainingsSessionsModal" />
</template>

<style lang="scss" scoped>
@use "assets/scss/texts";

.users-table-container {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 8px;
  flex-direction: column;
  overflow: auto;
  padding: 8px;
}

.users-table-container :deep(.index_layout),
.users-table-container :deep(.table_container) {
  max-height: 100%;
}
</style>
